export default "__VITE_ASSET___0YcWvUx__"